<template>
  <div class="form-group">
    <div class="mar-lt-20">
      <label class="pad-bt-5">{{ $t('upload.uploadLabel') }}</label>
      <el-upload
        action=""
        :on-change="handleChange"
        :on-remove="handleRemove"
        :on-exceed="handleExceed"
        :limit="1"
        :auto-upload="false"
        accept=".csv"
        ref="upload"
      >
        <el-button
          slot="trigger"
          class="btn add"
          size="small"
          type="primary"
        >{{ $t('upload.browse') }}</el-button>
        <el-button
          :disabled="!canUpload"
          style="margin-left: 10px;"
          class="btn add"
          size="small"
          type="primary"
          @click="upload"
        >{{ $t('upload.upload') }}</el-button>
        <div class="el-upload__tip" slot="tip">{{ $t('upload.file') }} .csv</div>
        <span class="el-upload-list__item-actions"></span>
      </el-upload>
    </div>
  </div>
</template>

<script>
  import swal from 'sweetalert2'

  export default {
    name: 'import-products-legacy-input',
    inheritAttrs: false,
    props: {
      location: Object
    },
    data () {
      return {
        apiUrl: '',
        file: null,
        uploading: false
      }
    },
    computed: {
      canUpload () {
        return !!this.file && !this.uploading && this.location && this.location.id
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
    },
    methods: {
      handleChange (file, fileList) {
        const isOkSize = file.size / 1024 / 1024 < 25
        const isCsv = file.raw.type === 'text/csv' || (file.name && file.name.toLowerCase().endsWith('.csv'))
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: this.$t('validations.pdfSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          this.$refs.upload.clearFiles()
          return
        }
        if (!isCsv) {
          swal({
            toast: true,
            type: 'warning',
            text: this.$t('validations.wrongFormat'),
            position: 'top-end',
            showConfirmButton: true,
            timer: 3000
          })
          this.$refs.upload.clearFiles()
          return
        }
        this.getBase64(file.raw).then((base64enc) => {
          this.file = base64enc
        })
      },
      handleRemove (file, fileList) {
        if (fileList.length === 0) {
          this.$refs.upload.files = []
          this.file = null
        }
      },
      handleExceed () {
        swal({
          toast: true,
          text: this.$t('validations.removePhoto'),
          type: 'warning',
          position: 'top-end',
          showConfirmButton: true
        })
      },
      getBase64 (file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = error => reject(error)
        })
      },
      upload () {
        if (!this.canUpload) {
          return
        }
        this.uploading = true
        const data = {
          token: this.$session.get('token'),
          // Legacy ImportController expects location token (same as ArchiveInput).
          location_id: this.location.id,
          company_id: this.$session.get('selectedCompany'),
          csv: this.file
        }

        this.apiRequest('/import-location/products/legacy', 'POST', data, (response) => {
          this.uploading = false
          if (response && response.status === true) {
            const locationTrueId = (this.location && this.location.true_id) || null
            this.trackAdminEvent('ADMIN_PRODUCT_IMPORT_LEGACY', 'product_import', locationTrueId, {
              location_id: locationTrueId,
              location_token: this.location.id || null,
              import_type: 'legacy',
              response: response
            })
            swal({
              toast: true,
              text: this.$t('productImport.legacyUploadSuccess'),
              type: 'success',
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            })
            this.file = null
            if (this.$refs.upload) {
              this.$refs.upload.clearFiles()
            }
          } else {
            swal({
              toast: true,
              text: (response && response.data) || this.$t('general.error'),
              type: 'error',
              position: 'top-end',
              showConfirmButton: false,
              timer: 4000
            })
          }
        })
      }
    }
  }
</script>

<style>
  p {
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Inputs/ImportProductsLegacyInput.vue